import { useState } from "react";
import { useTranslation } from "react-i18next";
import MaterialIcon from "react-google-material-icons";
import { BenefitModal } from "./benefit_modal";
import { BENEFIT_MODAL_DATA } from "./benefit_modal_data";

const CARDS = [
  { icon: "build",           value: "-30%", labelKey: "benefit_label_1", textKey: "benefit_text_1" },
  { icon: "factory",         value: "+15%", labelKey: "benefit_label_2", textKey: "benefit_text_2" },
  { icon: "manage_history",  value: "50%",  labelKey: "benefit_label_3", textKey: "benefit_text_3" },
];

export const Benefits = () => {
  const { t } = useTranslation();
  const [activeIdx, setActiveIdx] = useState(null);

  return (
    <section id="stats" className="stats-section">
      <div className="stats-container">

        <div className="stats-header">
          <div className="stats-title-group">
            <h2 className="stats-title">{t("Benefits.title")}</h2>
          </div>
        </div>

        <div className="stats-grid">
          {CARDS.map((card, i) => (
            <div
              key={i}
              className="kpi-card kpi-card--clickable"
              onClick={() => setActiveIdx(i)}
              role="button"
              tabIndex={0}
              onKeyDown={e => e.key === "Enter" && setActiveIdx(i)}
            >
              <div className="kpi-icon">
                <MaterialIcon icon={card.icon} size={50}/>
              </div>
              <div className="kpi-value">{card.value}</div>
              <p className="kpi-label">{t(`Benefits.${card.labelKey}`)}</p>
              <p className="kpi-description">{t(`Benefits.${card.textKey}`)}</p>
              <span className="kpi-card-hint">
                <MaterialIcon icon="open_in_new" size={16}/>
                <span>{t("Benefits.readmore") || "Mehr erfahren"}</span>
              </span>
            </div>
          ))}
        </div>

        {/* ── Whitepaper Teaser ── */}
        <div className="wp-teaser">

          <div className="wp-cover" aria-hidden="true">
            <div className="wp-cover-bar" />
            <div className="wp-cover-body">
              <p className="wp-cover-kicker">Kallideus Whitepaper · 2026</p>
              <h3 className="wp-cover-title">Pragmatische<br/>Digitalisierung</h3>
              <p className="wp-cover-subtitle">{t("Benefits.wp_subheading")}</p>
            </div>
            <div className="wp-cover-footer">
              <span className="wp-cover-logo">KALLIDEUS</span>
              <div className="wp-cover-pillars">
                <span>Beratung</span>
                <span>Software</span>
                <span>Training</span>
              </div>
            </div>
            <div className="wp-cover-free-badge">{t("Benefits.wp_free")}</div>
          </div>

          <div className="wp-info">
            <span className="wp-eyebrow">
              <MaterialIcon icon="article" size={15}/> {t("Benefits.wp_eyebrow")}
            </span>
            <h3 className="wp-heading">{t("Benefits.wp_heading")}</h3>
            <p className="wp-body">{t("Benefits.wp_body")}</p>

            <div className="wp-stats">
              <div className="wp-stat">
                <span className="wp-stat-value">+25%</span>
                <span className="wp-stat-label">{t("Benefits.wp_stat1")}</span>
              </div>
              <div className="wp-stat">
                <span className="wp-stat-value">-50%</span>
                <span className="wp-stat-label">{t("Benefits.wp_stat2")}</span>
              </div>
              <div className="wp-stat">
                <span className="wp-stat-value">200%+</span>
                <span className="wp-stat-label">{t("Benefits.wp_stat3")}</span>
              </div>
            </div>

            <div className="wp-actions">
              <a
                href="/WhitepaperPragmatischeDigitaliseierung.pdf"
                download
                className="wp-btn-download"
              >
                <MaterialIcon icon="download" size={18}/>
                {t("Benefits.wp_download")}
              </a>
              <a
                href="https://calendly.com/consulting-kallideus/30min"
                target="_blank"
                rel="noreferrer"
                className="wp-btn-expert"
              >
                <MaterialIcon icon="calendar_month" size={18}/>
                {t("Benefits.wp_expert")}
              </a>
            </div>
          </div>

        </div>

      </div>

      {activeIdx !== null && (
        <BenefitModal
          data={BENEFIT_MODAL_DATA[activeIdx]}
          onClose={() => setActiveIdx(null)}
        />
      )}
    </section>
  );
};
